module.exports = __webpack_public_path__ + "img/canLikeOff.2be87da3.svg";